import { makeStyles } from "@cirrus/ui-kit"

import { cx } from "ramda-extension/es"
import React, { Component as C } from "react"
import PropTypes from "prop-types"

import { withUseStyles } from "@cirrus/legacy/app-common/utils/withUseStyles.jsx"

import cv from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"

const useStyles = makeStyles({
  contentContainer: {
    position: "absolute",
    right: "0",
    top: "45px",
    zIndex: 100,
  },

  content: {
    border: `1px solid ${cv.white}`,
    backgroundColor: cv.white,
    borderRadius: "3px",
    margin: 0,
    padding: 0,
    listStyle: "none",
    boxShadow: `0 0 2px 0 ${cv.gray740}`,
  },
})

class Content extends C {
  constructor(props) {
    super(props)
    this.onClickOutside = this.onClickOutside.bind(this)
  }

  static propTypes = {
    onClickOutside: PropTypes.func,
    contentContainerClassName: PropTypes.string,
    contentClassName: PropTypes.string,
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onClickOutside)
  }

  componentWillMount() {
    document.addEventListener("click", this.onClickOutside)
  }

  onClickOutside() {
    this.props.onClickOutside && this.props.onClickOutside()
  }

  onClickInside(e) {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
  }

  render() {
    const { contentContainerClassName, contentClassName, children, classes } = this.props,
      contentContainerClasses = cx(classes.contentContainer, contentContainerClassName),
      contentClasses = cx(classes.content, contentClassName)

    return (
      <div className={contentContainerClasses}>
        <div className={contentClasses} onClick={this.onClickInside.bind(this)}>
          {children}
        </div>
      </div>
    )
  }
}

export default withUseStyles(Content, useStyles)
